import type { ClientContext } from '../lib/checkoutEvidence'

export type ChatComponent =
  | 'P'
  | 'UL'
  | 'LI'
  | 'DIVIDER'
  | 'INPUT'
  | 'TEXTAREA'
  | 'OTP'
  | 'DOT_NUMBER'
  | 'BUTTON_GROUP'
  | 'FILE_UPLOAD'
  | 'SIGN_AGREEMENT'
  | 'ADD_TELEMATICS'
  | 'ADD_DRIVERS'
  | 'ADD_EQUIPMENTS'
  | 'COVERAGE_START_DATE'
  | 'ADD_INSURANCE_COVERAGE'
  | 'CARD_CHECKBOX'
  | 'LINK'
  | 'CONFIRM_INFORMATION'
  | 'VERIFY_EMAIL'
  | 'LOSS_RUN_FORM'
  | 'EARLY_INDICATION'
  | 'LOADING_EARLY_INDICATION'
  | 'LOADING'
  | 'FREIGHT_ALLOCATION'
  | 'FORM'

export type ChatContentNested = ReadonlyArray<ChatContent> | ChatContent | string | undefined

export interface ChatAttachment {
  documentId: string
  attachmentId: string
  fileName: string
  fileExtension: string
  fileSize: number
  fileUrl: string | null
}

export interface ChatContent {
  content?: ChatContentNested
  component: ChatComponent
  props?: Record<string, unknown>
  attachments?: ChatAttachment[]
}

export interface ChatItem {
  id: string
  clientId?: string
  dateCreated: string
  dateUpdated: string
  createdBy?: string
  content: ChatContentNested
  isFromUser: boolean
  metadata?: Record<string, any>
  service?: string
  isEditable?: boolean
  editableAction?: ChatActionInterface | null
}

export interface ChatActionInterface {
  content: ChatContent
  service: string
  key?: string
}

export interface AttestationConsentPayload {
  attestation_type: string
  version: number
  content_hash: string
  bool_value: boolean
  attested_at: string
  documents_opened_at?: Record<string, string>
}

export interface ChatActionWithValue {
  content?: ChatContent
  service?: string
  clientId?: string
  value: string | number | Record<string, unknown> | string[] | Record<string, unknown>[]
  documentIds?: string[]
  attestations?: AttestationConsentPayload[]
  bind_attestations?: AttestationConsentPayload[]
  dom_html?: string
  dom_screenshot_b64?: string
  client_context?: ClientContext
}

export interface Chat {
  id: string
  dateCreated: string
  dateUpdated: string
  relatedModel: 'QUOTE'
  relatedModelId: string
  title: string
  items: ChatItem[]
}

function isChatContent(value: ChatContentNested): value is ChatContent {
  return typeof value === 'object' && value !== null && !Array.isArray(value) && 'component' in value
}

export function isParagraph(chatItem: ChatItem) {
  const content = chatItem.content
  if (!isChatContent(content)) {
    return false
  }
  return content.component === 'P'
}

export function isList(chatItem: ChatItem) {
  const content = chatItem.content
  return isChatContent(content) && content.component === 'UL'
}
